<template>
  <div class="page-listing-item pb-4 pb-lg-5 mb-4 mb-lg-5">
    <div class="document-content">
      <strong class="fs-large d-block document-content-title d-flex align-items-center mb-2">
        <div class="document-icon">
          <slot name="pdf-icon"></slot>
        </div>
        <i class="fst-normal" v-html="item.title"></i>
      </strong>
      <div v-if="item.description" class="rte" v-html="item.description"></div>
      <div class="document-variants">
        <div v-for="variant in item.variants" class="d-block d-lg-inline-block mt-3 me-lg-4">
          <a class="link-black text-uppercase text-decoration-underline" :href="variant.link" :aria-label="variant.ariaLabel ?? variant.title" target="_blank">{{ variant.title }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['item']
  }
</script>